export const COLLECTIONS_ERROR_ID = 'sitecollection-client';

export enum KEY_CODES {
    BACKSPACE = 8,
    TAB = 9,
    ENTER = 13,
    SHIFT = 16,
    CTRL = 17,
    ALT = 18,
    ESCAPE = 27,
    ARROW_UP = 38,
    ARROW_RIGHT = 39,
    ARROW_DOWN = 40,
    ARROW_LEFT = 41,
    DELETE = 46,
}

export enum PROVIDERS {
    USER = 'user',
    STORE = 'store',
}

export enum PopupTypes {
    CONFIRMATION = 'confirmation',
    FREESTYLE = 'freestyle',
    LIGHT_HEADER = 'light_header',
    DARK_HEADER = 'dark_header',
    SINGLE_BUTTON = 'single_button',
    INPUT = 'input',
}

export enum EditorMode {
    CUSTOMER_ANNOTATIONS = 'CUSTOMER_ANNOTATIONS',
    PREVIEW = 'PREVIEW',
    DEFAULT = 'DEFAULT',
    DEV = 'DEV',
    INSITE = 'INSITE',
    INSITE_PREVIEW = 'INSITE_PREVIEW',
    TEMPLATE_MODE = 'TEMPLATE_MODE',
    WIDGET_BUILDER_PREVIEW = 'WIDGET_BUILDER_PREVIEW',
    SECTIONS = 'SECTIONS',
    CREATE_SECTIONS = 'CREATE_SECTIONS',
    SELECT_ROWS = 'SELECT_ROWS',
    MOVE = 'MOVE',
    BLOG_POST_EDIT = 'BLOG_POST_EDIT',
    BLOG_LAYOUT_EDIT = 'BLOG_LAYOUT_EDIT',
    BLOG_ONLY = 'BLOG_ONLY',
    DYNAMIC = 'DYNAMIC',
    DUDAFLEX = 'DUDAFLEX',
}

export enum STATUS {
    SUCCESS = 'success',
    ERROR = 'error',
}

export enum AccountPlanType {
    ENTERPRISE = 'ENTERPRISE',
}

export enum CollectionFieldType {
    RICH_TEXT = 'text',
    PLAIN_TEXT = 'plain_text',
    IMAGE = 'image',
    LINK = 'link',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    DATE_TIME = 'date_time',
    BUSINESS_HOURS = 'business_hours',
    LOCATION = 'location',
    VIDEO = 'video',
    COLLECTION = 'collection',
    EMAIL = 'email',
    PHONE = 'phone',
    COLLECTION_REF = 'collection_ref',
    SOCIAL_ACCOUNTS = 'social_accounts',
    MULTI_SELECT = 'multi_select',
    ICON = 'icon',
    SINGLE_SELECT = 'single_select',
    DYNAMIC_PAGE = 'dynamic_page',
    STORE_PAGE = 'store_page',
}

export enum CopilotEvent {
    CREATE_COLLECTION = 'CREATE_COLLECTION',
    REFRESH_COLLECTION = 'REFRESH_COLLECTION',
    COPILOT_OPEN = 'COPILOT_OPEN',
    COPILOT_CLOSE = 'COPILOT_CLOSE',
    COPILOT_SET_CONTEXT = 'COPILOT_SET_CONTEXT',
    COPILOT_SET_PROMPT = 'COPILOT_SET_PROMPT',
    COPILOT_START_NEW_CHAT = 'COPILOT_START_NEW_CHAT',
    COPILOT_NEW_CHAT_STARTED = 'COPILOT_NEW_CHAT_STARTED',
    SET_COLLECTION_NAME_TAG = 'SET_COLLECTION_NAME_TAG',
}
